import configs from '../../../../../utils/configs';
import ListDropdown from '../../../Dropdowns/List/ListDropdown';
import {StyledShipsFromContainer, StyledShipsFromLabelContainer} from './styles';
import Props from './typings';

const ShipsFrom = ({selected, callback}: Props) => {
  const countryChanged = (key) => {
    callback(key);
  };

  return (
    <StyledShipsFromContainer>
      <StyledShipsFromLabelContainer>
        <h4>Artist country</h4>
      </StyledShipsFromLabelContainer>

      <ListDropdown
        options={configs.countries}
        type="inline"
        title="Select country"
        maxHeight={200}
        selected={selected}
        dropdownPosition="right"
        callback={countryChanged}
      />
    </StyledShipsFromContainer>
  );
};

export default ShipsFrom;
